/**
 * Calm, helpful empty state. `children` holds actions.
 * Pass `as="h1"` when it is the main content of a page and there is no other h1.
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  as: Heading = 'h2',
  children,
  className = '',
}) {
  return (
    <div className={`mx-auto flex max-w-lg flex-col items-center px-2 py-14 text-center ${className}`}>
      {Icon && (
        <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-surface-alt text-ink">
          <Icon className="h-6 w-6" />
        </span>
      )}
      <Heading className="font-display text-2xl text-ink sm:text-3xl">{title}</Heading>
      {description && <p className="mt-3 max-w-md text-pretty text-muted">{description}</p>}
      {children && <div className="mt-7 flex flex-wrap justify-center gap-3">{children}</div>}
    </div>
  );
}
